import { QueryKeys } from './common';

export const GitQueryKeys = {
  Versions: [QueryKeys.Git, 'Versions'],
  GitDiff: [QueryKeys.Git, 'GitDiff'],
  BranchDivergence: [QueryKeys.Git, 'BranchDivergence'],
  Branch: [QueryKeys.Git, 'Branch'],
  Branches: [QueryKeys.Git, 'Branches'],
  ProjectPipelines: [QueryKeys.Git, QueryKeys.Project, 'Pipelines'],
  Info: [QueryKeys.Git, 'Info'],
  PullUrl: [QueryKeys.Git, QueryKeys.Project, 'PullUrl'],
  PullRequest: [QueryKeys.Git, QueryKeys.Project, 'PullRequest'],
  GitDiffV2: [QueryKeys.Git, QueryKeys.Project, 'GitDiffV2'],
  CommitInfo: [QueryKeys.Git, 'Branch', 'CommitInfo'],
  SyncLangInfo: [QueryKeys.Git, 'SyncLangInfo'],
  ExternalGitStatus: [QueryKeys.Project, QueryKeys.Git, 'ExternalGitStatus'],
  AllDivergences: [QueryKeys.Git, QueryKeys.Project, 'AllDivergences'],
  BumpVersionSuggestions: [QueryKeys.Git, QueryKeys.Project, 'BumpVersionSuggestions'],
  LatestVersionDetail: [QueryKeys.Git, QueryKeys.Project, 'LatestVersionDetail']
};
